export default class EmailInputService {
    initEmailInputsValidation() {
        const emailInputs = document.querySelectorAll('input[name="email"]');
        emailInputs.forEach((emailInput) => {
            if (!emailInput) {
                return;
            }
            const inputContainer = emailInput.closest('.input-container');
            emailInput === null || emailInput === void 0 ? void 0 : emailInput.addEventListener('blur', () => {
                if (!inputContainer) {
                    return;
                }
                const emailRegex = /^\S+@\S+$/;
                if (!emailRegex.test(emailInput.value)) {
                    inputContainer.classList.add('error');
                }
                else {
                    inputContainer.classList.remove('error');
                }
            });
            emailInput === null || emailInput === void 0 ? void 0 : emailInput.addEventListener('beforeinput', (e) => {
                if (!inputContainer) {
                    return;
                }
                const emailRegex = /^\S+@\S+$/;
                if (!emailRegex.test(emailInput.value)) {
                    inputContainer.classList.add('error');
                }
                else {
                    inputContainer.classList.remove('error');
                }
            });
        });
    }
    init() {
        this.initEmailInputsValidation();
    }
}
